import { render, staticRenderFns } from "./AppendixRent.vue?vue&type=template&id=264f0476&scoped=true"
import script from "./AppendixRent.vue?vue&type=script&lang=js"
export * from "./AppendixRent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f0476",
  null
  
)

export default component.exports